import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AlertPanelSeverity = 'info' | 'warning' | 'error';

const ICONS: Record<AlertPanelSeverity, string> = {
  info: 'fa-info-circle',
  warning: 'fa-warning',
  error: 'fa-exclamation-circle',
};

@Component({
  selector: 'app-alert-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-panel.component.html',
  styleUrls: ['./alert-panel.component.scss'],
})
export class AlertPanelComponent {
  @Input() severity: AlertPanelSeverity = 'info';
  @Input() heading: string;

  protected get icon() {
    return ICONS[this.severity];
  }
}
